import script from "./DetailProfileKontraktorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailProfileKontraktorPage.vue?vue&type=script&setup=true&lang=js"

import "./DetailProfileKontraktorPage.vue?vue&type=style&index=0&id=6e495c03&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e495c03"]])

export default __exports__